import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ButtonBase } from "@material-ui/core";
import "./PaymentInformationStyle.scss";
import { getErrorByName } from "../../../../../../../Helper";
import { AutocompleteComponent, Inputs } from "../../../../../../../Components";
import { GetLookupItemsByLookupTypeName } from "../../../../../../../Services";

export const PaymentInformationComponent = ({
  parentTranslationPath,
  translationPath,
  state,
  selected,
  onChangeHandler,
  setIsMissingInfoMSGOpen,
  GetPaymentFormById,
  schema,
  isSubmitted,
  isLoadingForm,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const searchTimer = useRef(null);
  const [isLoading, setIsLoading] = useState({
    accountTypes: null,
    currencies: null,
    countries: null,
  });

  const [lookupList, setLookupList] = useState([
    { id: "Bank Account", name: "accountTypes" },
    { id: "currency", name: "currencies" },
    { id: "country", name: "countries" },
  ]);

  const [data, setData] = useState({
    accountTypes: [],
    currencies: [],
    countries: [],
  });

  const GetLookupItemsByLookupTypeNameAPI = async (lookupName, key, search) => {
    setIsLoading((item) => ({ ...item, [key]: true }));
    const res = await GetLookupItemsByLookupTypeName({
      lookUpName: lookupName,
      pageSize: 1000,
      pageIndex: 1,
    });
    if (!(res && res.status && res.status !== 200)) {
      const result =
        (res && res.result).map((item) => ({
          id: item.lookupItemId,
          name: item.lookupItemName,
        })) || [];
      setData((item) => ({ ...item, [key]: result }));
    } else {
      setData((item) => ({ ...item, [key]: [] }));
    }
    setIsLoading((item) => ({ ...item, [key]: false }));
  };

  useEffect(() => {
    if (lookupList?.length)
      lookupList.map((item) =>
        GetLookupItemsByLookupTypeNameAPI(item?.id, item?.name)
      );
  }, [lookupList]);

  return (
    <div className="payment-container w-100">
      <div className="button-group">
        <ButtonBase
          type="button"
          className="discard"
          onClick={() => {
            GetPaymentFormById();
          }}
        >
          {t(`${translationPath}discard`)}
        </ButtonBase>
        <ButtonBase
          className="btns theme-propx solid"
          id="btn-save"
          onClick={() => {
            setIsMissingInfoMSGOpen(true);
          }}
          disabled={
            isLoadingForm ||
            !state?.id ||
            isLoading.accountTypes ||
            isLoading.currencies ||
            isLoading.countries
          }
        >
          {t(`${translationPath}save`)}
        </ButtonBase>
      </div>
      <h2>{t(`${translationPath}payment-information`)}</h2>
      <p className="note">
        {t(
          `${translationPath}Changes-made-here-will-be-reflected-on-the-member-portal`
        )}
      </p>
      <div className="form px-2">
        <div className="form-group">
          <label htmlFor="accountHolder" className="px-2 fw-bold">
            {t(`${translationPath}account-holder-name`)} {" *"}
          </label>
          <div className="px-2 w-100">
            <Inputs
              idRef={"AccountHolderNamRef"}
              type={"text"}
              value={state?.accountHolderName || ""}
              onInputChanged={(e) => {
                const value = e.target.value || null;
                onChangeHandler("accountHolderName", value);
              }}
              translationPath={translationPath}
              parentTranslationPath={parentTranslationPath}
              helperText={getErrorByName(schema, "accountHolderName").message}
              error={getErrorByName(schema, "accountHolderName").error}
              isWithError
              isSubmitted={isSubmitted}
            />
          </div>
        </div>
        <div className="form-group ">
          <label htmlFor="accountType" className="px-2 fw-bold">
            {t(`${translationPath}account-type`)} {" *"}
          </label>
          <div className="px-2 w-100">
            <AutocompleteComponent
              idRef="AccountTypeRef"
              selectedValues={selected?.accountType || null}
              multiple={false}
              data={data?.accountTypes || []}
              displayLabel={(option) => option?.name || ""}
              renderOption={(option) =>
                (option?.name && `${option.name}`) || ""
              }
              getOptionSelected={(option) =>
                option?.id === state?.accountTypeId
              }
              withoutSearchButton
              isLoading={isLoading?.accountTypes}
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
              onChange={(event, newValue) => {
                onChangeHandler(
                  "accountTypeId",
                  newValue?.id,
                  "accountType",
                  newValue
                );
              }}
              helperText={getErrorByName(schema, "accountTypeId").message}
              error={getErrorByName(schema, "accountTypeId").error}
              isWithError
              isSubmitted={isSubmitted}
            />
          </div>
        </div>
        <div className="form-group">
          <label className="px-2" htmlFor="bankName">
            {t(`${translationPath}country`)}
          </label>
          <div className="px-2 w-100">
            <AutocompleteComponent
              idRef="countryRef"
              selectedValues={selected?.country || null}
              multiple={false}
              data={data?.countries || []}
              displayLabel={(option) => option?.name || ""}
              renderOption={(option) =>
                (option?.name && `${option.name}`) || ""
              }
              getOptionSelected={(option) => option?.id === state?.countryId}
              withoutSearchButton
              isLoading={isLoading?.countries}
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
              onChange={(event, newValue) => {
                onChangeHandler(
                  "countryId",
                  newValue?.id || null,
                  "country",
                  newValue
                );
              }}
            />
          </div>
        </div>
        <div className="form-group">
          <label className="px-2" htmlFor="bankName">
            {t(`${translationPath}bank-name`)}
          </label>
          <div className="px-2 w-100">
            <Inputs
              idRef={"bankRef"}
              type={"text"}
              value={state?.bankName || ""}
              onInputChanged={(e) => {
                const value = e.target.value === "" ? null : e.target.value;
                onChangeHandler("bankName", value);
              }}
              translationPath={translationPath}
              parentTranslationPath={parentTranslationPath}
            />
          </div>
        </div>
        <div className="form-group">
          <label className="px-2" htmlFor="bank-branch-name">
            {t(`${translationPath}bank-branch-name`)}
          </label>
          <div className="d-flex px-2 w-100">
            <Inputs
              idRef={"BankBranchNameRef"}
              type={"text"}
              value={state?.bankBranchName || ""}
              onInputChanged={(e) => {
                const value = e.target.value === "" ? null : e.target.value;
                onChangeHandler("bankBranchName", value);
              }}
              translationPath={translationPath}
              parentTranslationPath={parentTranslationPath}
            />
          </div>
        </div>
        <div className="form-group">
          <label className="px-2" htmlFor="bank-account-number">
            {t(`${translationPath}bank-account-number`)}
          </label>
          <div className="px-2 w-100">
            <Inputs
              idRef={"BankAccountNumberRef"}
              type={"text"}
              value={state?.bankAccountNumber || ""}
              onInputChanged={(e) => {
                const value = e.target.value === "" ? null : e.target.value;
                onChangeHandler("bankAccountNumber", value);
              }}
              translationPath={translationPath}
              parentTranslationPath={parentTranslationPath}
            />
          </div>
        </div>
        <div className="form-group">
          <label className="px-2" htmlFor="iban">
            {t(`${translationPath}iban`)} {" *"}
          </label>
          <div className="px-2 w-100">
            <Inputs
              idRef={"ibanRef"}
              type={"text"}
              value={state?.iban || ""}
              onInputChanged={(e) => {
                const value = e.target.value === "" ? null : e.target.value;
                onChangeHandler("iban", value);
              }}
              translationPath={translationPath}
              parentTranslationPath={parentTranslationPath}
              helperText={getErrorByName(schema, "iban").message}
              error={getErrorByName(schema, "iban").error}
              isWithError
              isSubmitted={isSubmitted}
            />
          </div>
        </div>
        <div className="form-group">
          <label className="px-2" htmlFor="swift-code">
            {t(`${translationPath}swift-code`)} {" *"}
          </label>
          <div className="px-2 w-100">
            <Inputs
              idRef={"swiftCodeRef"}
              type={"text"}
              value={state?.swiftCode || ""}
              onInputChanged={(e) => {
                const value = e.target.value === "" ? null : e.target.value;
                onChangeHandler("swiftCode", value);
              }}
              translationPath={translationPath}
              parentTranslationPath={parentTranslationPath}
              helperText={getErrorByName(schema, "swiftCode").message}
              error={getErrorByName(schema, "swiftCode").error}
              isWithError
              isSubmitted={isSubmitted}
            />
          </div>
        </div>
        <div className="form-group">
          <label className="px-2 " htmlFor="currency">
            {t(`${translationPath}currency`)} {" *"}
          </label>
          <div className="px-2 w-100">
            <AutocompleteComponent
              idRef="currencyRef"
              selectedValues={selected?.currency || null}
              multiple={false}
              data={data?.currencies || []}
              displayLabel={(option) => option?.name || ""}
              renderOption={(option) =>
                (option?.name && `${option.name}`) || ""
              }
              getOptionSelected={(option) => option?.id === state?.currencyId}
              withoutSearchButton
              isLoading={isLoading.bankName}
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
              onChange={(event, newValue) => {
                onChangeHandler(
                  "currencyId",
                  newValue?.id || null,
                  "currency",
                  newValue
                );
              }}
              helperText={getErrorByName(schema, "currencyId").message}
              error={getErrorByName(schema, "currencyId").error}
              isWithError
              isSubmitted={isSubmitted}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
